package org.solyton.solawi.bid.module.banking.`data`.legalentity

import kotlin.String
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.user.`data`.address.Address
import org.solyton.solawi.bid.module.values.LegalEntityId

/**
 * Autogenerated ReadOnly Lens.
 * Read [LegalEntity.legalEntityId]
 */
@ReadOnly
public val legalEntityId: Lens<LegalEntity, LegalEntityId> by lazy {
      Lens(
        get = { whole -> whole.legalEntityId },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [LegalEntity.partyId]
 */
@ReadOnly
public val partyId: Lens<LegalEntity, LegalEntityId> by lazy {
      Lens(
        get = { whole -> whole.partyId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [LegalEntity.name]
 */
@ReadWrite
public val name: Lens<LegalEntity, String> by lazy {
      Lens(
        get = { whole -> whole.name },
        set = { part -> { whole -> whole.copy(name = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [LegalEntity.name]
 */
@ReadWrite
public fun LegalEntity.name(`set`: String.() -> String): LegalEntity = copy(name = set(name))

/**
 * Autogenerated Lens.
 * Read and manipulate [LegalEntity.legalForm]
 */
@ReadWrite
public val legalForm: Lens<LegalEntity, String?> by lazy {
      Lens(
        get = { whole -> whole.legalForm },
        set = { part -> { whole -> whole.copy(legalForm = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [LegalEntity.legalForm]
 */
@ReadWrite
public fun LegalEntity.legalForm(`set`: String?.() -> String?): LegalEntity = copy(legalForm =
    set(legalForm))

/**
 * Autogenerated Lens.
 * Read and manipulate [LegalEntity.legalEntityType]
 */
@ReadWrite
public val legalEntityType: Lens<LegalEntity, LegalEntityType> by lazy {
      Lens(
        get = { whole -> whole.legalEntityType },
        set = { part -> { whole -> whole.copy(legalEntityType = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [LegalEntity.legalEntityType]
 */
@ReadWrite
public fun LegalEntity.legalEntityType(`set`: LegalEntityType.() -> LegalEntityType): LegalEntity =
    copy(legalEntityType = set(legalEntityType))

/**
 * Autogenerated Lens.
 * Read and manipulate [LegalEntity.address]
 */
@ReadWrite
public val address: Lens<LegalEntity, Address> by lazy {
      Lens(
        get = { whole -> whole.address },
        set = { part -> { whole -> whole.copy(address = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [LegalEntity.address]
 */
@ReadWrite
public fun LegalEntity.address(`set`: Address.() -> Address): LegalEntity = copy(address =
    set(address))
